
import React, { createContext, useState, useMemo } from "react";
import { fnAutomationHistory, fnCreateNewAutomation, fnDeleteAutomation, fnGetAutomationData, fnInactiveAutomation, fnListAutomation, fnUpdateAutomation } from "../services/automation";
import useDataApi from "../hooks/useDataApi";

export const automationContext = createContext(null);

export const AutomationContextProvider = ({ children }) => {
    const [bIsEditAutomation, fnSetBIsEditAutomation] = useState(false)
    const [bOpenNewAutomation, fnSetBOpenNewAutomation] = useState(false)
    const [bUpdatedAutomationList, fnSetBUpdatedAutomationList] = useState(false)
    const [oAutomation, fnSetOAutomation] = useState({})
    const [oNewAutomationRes, fnONewAutomationReq] = useDataApi(fnCreateNewAutomation)
    const [oAutomationList, fnAutomationListReq] = useDataApi(fnListAutomation)
    const [oGetAutomationData, fnGetAutomationDataReq] = useDataApi(fnGetAutomationData)
    const [oUpdateAutomationRes, fnUpdateAutomationReq] = useDataApi(fnUpdateAutomation)
    const [oDeleteAutomationRes, fnDeleteAutomationReq] = useDataApi(fnDeleteAutomation)
    const [oListAutomationRes, fnListAutomationReq] = useDataApi(fnListAutomation)
    const [oChangeInactiveAutomationRes, fnChangeInactiveAutomationReq] = useDataApi(fnInactiveAutomation)
    const [bShareAutomation, fnSetBShareAutomation] = useState(false)
    const [bActiveAutomation, fnSetBActiveAutomation] = useState(false)
    const [oAutomationHistoryRes, fnAutomationHistoryReq] = useDataApi(fnAutomationHistory)





    async function fnOpenNewAutomation(oAutomation, bIsActive = false) {
        fnSetBActiveAutomation(bIsActive)
        if (oAutomation?.id) {
            const response = await fnGetAutomationDataReq(oAutomation?.id)
            fnSetOAutomation(oAutomation)
            fnSetBIsEditAutomation(true)
            fnSetBOpenNewAutomation(true)
            return
        }
        fnSetBOpenNewAutomation(true)
        fnSetBIsEditAutomation(false)
        return
    }

    function fnOpenShareAutomation(data) {
        fnSetBShareAutomation(true)
        fnSetBOpenNewAutomation(true)
        fnSetOAutomation(data)
    }

    function fnCloseNewAutomation() {
        fnSetBOpenNewAutomation(false)
        fnSetBIsEditAutomation(false)
        fnSetBShareAutomation(false)
        fnSetBActiveAutomation(false)
        fnSetOAutomation({})
    }


    const value = useMemo(() => {
        return {
            bIsEditAutomation,
            fnSetBIsEditAutomation,
            bOpenNewAutomation,
            fnSetBOpenNewAutomation,
            oAutomation,
            fnSetOAutomation,
            fnOpenNewAutomation,
            fnCloseNewAutomation,
            oNewAutomationRes,
            fnONewAutomationReq,
            oAutomationList,
            fnAutomationListReq,
            oGetAutomationData,
            fnGetAutomationDataReq,
            oUpdateAutomationRes,
            fnUpdateAutomationReq,
            fnOpenShareAutomation,
            bShareAutomation,
            oDeleteAutomationRes,
            fnDeleteAutomationReq,
            oChangeInactiveAutomationRes,
            fnChangeInactiveAutomationReq,
            bActiveAutomation,
            oAutomationHistoryRes,
            fnAutomationHistoryReq,
            fnListAutomationReq,
            oListAutomationRes,
            bUpdatedAutomationList,
            fnSetBUpdatedAutomationList
        };
    }, [
        bIsEditAutomation,
        fnSetBIsEditAutomation,
        bOpenNewAutomation,
        fnSetBOpenNewAutomation,
        oAutomation,
        fnSetOAutomation,
        fnOpenNewAutomation,
        fnCloseNewAutomation,
        oNewAutomationRes,
        fnONewAutomationReq,
        oAutomationList,
        fnAutomationListReq,
        oGetAutomationData,
        fnGetAutomationDataReq,
        oUpdateAutomationRes,
        fnUpdateAutomationReq,
        bShareAutomation,
        oDeleteAutomationRes,
        fnDeleteAutomationReq,
        oChangeInactiveAutomationRes,
        fnChangeInactiveAutomationReq,
        bActiveAutomation,
        oAutomationHistoryRes,
        fnAutomationHistoryReq,
        fnListAutomationReq,
        oListAutomationRes,
        bUpdatedAutomationList,
        fnSetBUpdatedAutomationList
    ]);

    return (
        <automationContext.Provider value={value}>
            {children}
        </automationContext.Provider>
    )
}

export default automationContext;